module.exports = __webpack_public_path__ + "img/guante-7.bad414cc.jpg";